import React, { useState, useEffect, } from "react";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import axios from "axios";
import axiosInstance from "../../../ReusableComponents/Axios";

export function HBookDD(props) {
  const [BookOptions, SetBookOptions] = useState();
  const GetBooks = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetHindiBookOnGradeAndUnit?Grade=${props.Grade}&Unit=${props.Chapter}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const Options = res.data.map((item) => ({
          display: item.hindiBookValue,
          value: item.hindiBookLovId,
        }));
        SetBookOptions(Options);
        if (Options.filter((item) => item.value === props.SOption).length > 0) {
          props.StoreMSource(props.SOption);
        } else {
          props.StoreMSource("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Chapter && props.Grade && props.GCtype) {
      GetBooks();
    }
  }, [props.Grade, props.Chapter, props.GCtype]);

  return (
    <>
      <DropdownValues
        className={props.className}
        options={BookOptions}
        selectoption={props.SOption}
        onChange={(e) => props.onChange(e.target.value)}
        disabled={props.disable}
        labelname={props.labelname}
        Displayname={props.Displayname}
      />
    </>
  );
}

const HBookSubDropDowns = (props) => {
  const dispatch = useDispatch();

  const [BSDD, SetBSDD] = useState({ MR: "", Poem: "", NDL: "" });
  const [SValue, SetSValue] = useState({
    MR: props.SOption?.MR || "",
    Poem: props.SOption?.Poem || "",
    NDL: props.SOption?.NDL || "",
  });

  const GetMReading = async () => {
    SetBSDD({ MR: "", Poem: "", NDL: "" });
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetHindiAllBookDetail?Grade=${props.Grade}&Unit=${props.Chapter}&Book=${props.Book}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        const MR = [];
        const Poem = [];
        const NDL = [];
        const mrSet = new Set();
        const poemSet = new Set();
        res.data.forEach((item) => {
          if (item.hindiMainReadingLovId &&
            !mrSet.has(item.hindiMainReadingLovId)
          ) {
            mrSet.add(item.hindiMainReadingLovId);
            MR.push({
              display: item.hindiMainReadingValue,
              value: item.hindiMainReadingLovId,
            });
          }
          if (item.hindiMainReadingPoemLovId &&
            !poemSet.has(item.hindiMainReadingPoemLovId)) {
            poemSet.add(item.hindiMainReadingPoemLovId);
            Poem.push({
              display: item.hindiMainReadingPoemValue,
              value: item.hindiMainReadingPoemLovId,
            });
          }
          if (item.hindiLessonLovId) {
            NDL.push({
              display: item.hindiLessonValue,
              value: item.hindiLessonLovId,
            });
          }
        });
        SetBSDD({ MR: MR, Poem: Poem, NDL: NDL });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Grade && props.Chapter && props.Book && props.GCtype) {
      GetMReading();
    }
  }, [props.Grade, props.Chapter, props.Book, props.GCtype]);

  const HandleoNchange = (e, Name) => {
    SetSValue({ ...SValue, [Name]: e });
    props.StoreMSource({ ...SValue, [Name]: e });
  };
  return (
    <>
      <Row>
        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.MR}
            selectoption={SValue.MR}
            onChange={(e) => HandleoNchange(e.target.value, "MR")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Main Reading</div>}
            Displayname="Select Main Reading"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.Poem}
            selectoption={SValue.Poem}
            onChange={(e) => HandleoNchange(e.target.value, "Poem")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Poem</div>}
            Displayname="Select Poem"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BSDD?.NDL}
            selectoption={SValue.NDL}
            onChange={(e) => HandleoNchange(e.target.value, "NDL")}
            disabled={props.disable}
            labelname={
              <div className="DropdownHeader">Non-Detailed Lesson</div>
            }
            Displayname="Select Non-Detailed Lesson"
          />
        </Col>
      </Row>
    </>
  );
};
export default HBookSubDropDowns;

export function HBookTypeSubDropDowns(props) {
  const [BTSDD, SetBTSDD] = useState({
    SS: "",
    Poem: "",
    NFI: "",
    DI: "",
    Essay: "",
  });
  const [SValue, SetSValue] = useState({
    SS: props.SOption?.SS || "",
    Poem: props.SOption?.Poem || "",
    NFI: props.SOption?.NFI || "",
    DI: props.SOption?.DI || "",
    Essay: props.SOption?.Essay || "",
  });

  const GetMReading = async () => {
    SetBTSDD({ SS: "", Poem: "", NFI: "", DI: "", Essay: "" });
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/Scenario/GetHindiAllBookDetail?Grade=${props.Grade}&Unit=${props.Chapter}&Book=${props.Book}&GCType=${props.GCtype}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        SetBTSDD({
          SS: res.data[0].hindiShortStoriesId && [
            {
              display: res.data[0].hindiShortStoriesValue,
              value: res.data[0].hindiShortStoriesId,
            },
          ],
          Poem: res.data[0].hindiMainReadingPoemLovId && [
            {
              display: res.data[0].hindiMainReadingPoemValue,
              value: res.data[0].hindiMainReadingPoemLovId,
            },
          ],
          NFI: res.data[0].nonFictionIntroductionId && [
            {
              display: res.data[0].nonFictionIntroduction,
              value: res.data[0].nonFictionIntroductionId,
            },
          ],
          DI: res.data[0].dramaIntroductionId && [
            {
              display: res.data[0].dramaIntroduction,
              value: res.data[0].dramaIntroductionId,
            },
          ],
          Essay: res.data[0].essayId && [
            { display: res.data[0].essay, value: res.data[0].essayId },
          ],
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.Grade && props.Chapter && props.Book && props.GCtype) {
      GetMReading();
    }
  }, [props.Grade, props.Chapter, props.Book, props.GCtype]);

  const HandleoNchange = (e, Name) => {
    SetSValue({ ...SValue, [Name]: e });
    props.StoreMSource({ ...SValue, [Name]: e });
  };
  console.log("SValue", SValue);

  return (
    <>
      <Row>
        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BTSDD?.SS}
            selectoption={SValue?.SS}
            onChange={(e) => HandleoNchange(e.target.value, "SS")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Short Stories</div>}
            Displayname="Select Short Stories"
          />
        </Col>

        <Col>
          {" "}
          <DropdownValues
            className={props.className}
            options={BTSDD?.Poem}
            selectoption={SValue?.Poem}
            onChange={(e) => HandleoNchange(e.target.value, "Poem")}
            disabled={props.disable}
            labelname={<div className="DropdownHeader">Poem</div>}
            Displayname="Select Poem"
          />
        </Col>

        {props.Grade === 51 ? (
          <Col>
            {" "}
            <DropdownValues
              className={props.className}
              options={BTSDD?.Essay}
              selectoption={SValue?.Essay}
              onChange={(e) => HandleoNchange(e.target.value, "Essay")}
              disabled={props.disable}
              labelname={<div className="DropdownHeader">Essay</div>}
              Displayname="Select Essay"
            />
          </Col>
        ) : (
          <>
            <Col>
              {" "}
              <DropdownValues
                className={props.className}
                options={BTSDD?.NFI}
                selectoption={SValue?.NFI}
                onChange={(e) => HandleoNchange(e.target.value, "NFI")}
                disabled={props.disable}
                labelname={
                  <div className="DropdownHeader">Non-Fiction Introduction</div>
                }
                Displayname="Select Non-Fiction Introduction"
              />
            </Col>

            <Col>
              {" "}
              <DropdownValues
                className={props.className}
                options={BTSDD?.DI}
                selectoption={SValue?.DI}
                onChange={(e) => HandleoNchange(e.target.value, "DI")}
                disabled={props.disable}
                labelname={
                  <div className="DropdownHeader">Drama-Introduction</div>
                }
                Displayname="Select Drama-Introduction"
              />
            </Col>
          </>
        )}
      </Row>
    </>
  );
}